import script from "./TagGroupItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TagGroupItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"TagGroupItem.vue"]])

export default __exports__